import React, { Component } from 'react'
import './index.less'

import Gift from '../Gift'

export default class extends Component {

  celeTitle = () => {
    const { config, language } = this.props
    if (language == 'ar') {
      return config.contentTitleAr
    }
    else if (language == 'en') {
      return config.contentTitle
    }
    else if (language == 'tr') {
      return config.contentTitleTr
    }
    else if (language == 'zh') {
      return config.contentTitleZh
    }
    else if (language == 'jp') {
      return config.contentTitleJp
    }
  }
  celeContent = () => {
    const { config, language } = this.props
    if (language == 'ar') {
      return config.contentTxtAr
    }
    else if (language == 'en') {
      return config.contentTxt
    }
    else if (language == 'tr') {
      return config.contentTxtTr
    }
    else if (language == 'zh') {
      return config.contentTxtZh
    }
    else if (language == 'jp') {
      return config.contentTxtJp
    }
  }

  render() {
    // 主题
    const { topBg, centerBg, bottomBg, titleBg, giftList } = this.props

    return (
      <div className='nt-celebration-wrap'>
        <div className="nt-cb-main" style={{ backgroundImage: `url(${centerBg || ''})` }}>
          <div className="nt-top-bg" style={{ backgroundImage: `url(${topBg || ''})` }}></div>
          <div className="nt-bottom-bg" style={{ backgroundImage: `url(${bottomBg || ''})` }}></div>
          <div className="cb-title" style={{ backgroundImage: `url(${titleBg || ''})` }}>
            {this.celeTitle()}
          </div>
          <div className="cb-content">
            <div className="wish-desc" dangerouslySetInnerHTML={{ __html: this.celeContent() || '' }}></div>
            {/* 礼物列表 */}
            <Gift giftList={giftList} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/Celebration/index.js